import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Layout, Typography, Card, Form, Input, Row, Col, Spin } from "antd";
import { useNavigate } from "react-router-dom";

// PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, staticConfig } from "../systemAdmin.config";
import cnt from "../../../services/definedConstant";

const { Text, Title } = Typography;

const ViewSmsService = (props) => {
  const { userData } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getSmsServiceConfig();
  }, []);

  useEffect(() => {
    BOM.HasPermission("READ_BOND");
    BOM.HasPermission("CREATE_BOND");
    BOM.HasPermission("CREATE_BOND") && dispatch({ type: cnt.RIGHT_EDIT_BTN });
  }, []);

  /** ---------------------------
   * GET SMS SERVICE CONFIGURATION
   * -------------------------- */
  const getSmsServiceConfig = () => {
    setIsLoading(true);

    const url = `${apiConfig.ExternalServiceSMS}/SMS`; // ✅ adjust endpoint if needed
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
        return;
      }

      // ✅ Convert array to object and remove duplicates
      const formatted = {};
      (res || []).forEach((item) => {
        if (!formatted[item.name]) {
          formatted[item.name] = item.value || "";
        }
      });

      // ✅ Set all relevant form fields
      form.setFieldsValue({
        host_name: formatted.host_name || "",
        port_number: formatted.port_number || "",
        end_point: formatted.end_point || "",
        tenant_app_key: formatted.tenant_app_key || "",
      });
    });
  };

  /** Navigate to edit page */
  const handleOnEdit = () => {
    navigate("/edit-sya2800");
  };

  return (
    <MainLayout isEnableRightSidebar={true} onEdit={handleOnEdit}>
      <TopContent
        pageTitle={"View SMS Service Configuration"}
        pageItems={staticConfig.viewExternalNotifcationSmsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" disabled>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="host_name"
                    label={<Text strong>Host Name</Text>}
                  >
                    <Input placeholder="Host Name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="port_number"
                    label={<Text strong>Port Number</Text>}
                  >
                    <Input placeholder="Port Number" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="end_point"
                    label={<Text strong>End Point</Text>}
                  >
                    <Input placeholder="End Point" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="tenant_app_key"
                    label={<Text strong>Tenant App Key</Text>}
                  >
                    <Input placeholder="Tenant App Key" />
                  </Form.Item>
                </Col>
              </Row>


            </Card>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(ViewSmsService);
